import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_SECURITIES = gql`
  query fetchFinancialProducts($input: FetchFinancialProductsInput!) {
    fetchFinancialProducts(input: $input) {
      financialProducts {
        id
        ticker
        isCash
        translatedName {
          ${TRANSLATED_STRING_FIELDS}
        }
        primaryAssetClass{
          id
          name
          translatedName {
            ${TRANSLATED_STRING_FIELDS}
          }
        }
        secondaryAssetClass{
          id
          name
          translatedName {
            ${TRANSLATED_STRING_FIELDS}
          }
        }
        tertiaryAssetClass {
          id
          name
          translatedName {
            ${TRANSLATED_STRING_FIELDS}
          }
        }
      }
    }
  }
`;

export const FETCH_HOLDINGS = gql`
  query fetchHoldings($input: FetchHoldingsInput!) {
    fetchHoldings(input: $input) {
      holdings {
        financialProduct {
          id
          ticker
          isCash
          translatedName {
            ${TRANSLATED_STRING_FIELDS}
          }
          primaryAssetClass{
            id
            name
            translatedName {
              ${TRANSLATED_STRING_FIELDS}
            }
          }
          secondaryAssetClass{
            id
            name
            translatedName {
              ${TRANSLATED_STRING_FIELDS}
            }
          }
          tertiaryAssetClass {
            id
            name
            translatedName {
              ${TRANSLATED_STRING_FIELDS}
            }
          }
        }
      }
    }
  }
`;
